import { FaMapSigns } from "react-icons/lib/fa";
import React from "react";
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";
import { withNamespaces } from "react-i18next";

class Legend extends React.Component {
  render() {
    const { t } = this.props;
    return (
      <React.Fragment>
        <Modal isOpen={this.props.open} toggle={this.props.toggle}>
          <ModalHeader>
            <FaMapSigns className="icon" /> {t("legend-modal-title")}
          </ModalHeader>
          <ModalBody>
            <h3>{t("legend-footpath")}</h3>
            <hr style={{ border: "4px solid #b141e3" }} />
            <p>{t("legend-footpath-desc")}</p>

            <h3>{t("legend-bridleway")}</h3>
            <hr style={{ border: "4px solid #1FAE0E" }} />
            <p>{t("legend-bridleway-desc")}</p>

            <h3>{t("legend-restricted-byway")}</h3>
            <hr style={{ border: "4px dashed #31EE03" }} />
            <p>{t("legend-restricted-byway-desc")}</p>
            
            <h3>{t("legend-byway")}</h3>
            <hr style={{ border: "4px solid #7F4229" }} />
            <p>{t("legend-byway-desc")}</p>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.props.toggle}>
              {t("legend-close")}
            </Button>
          </ModalFooter>
        </Modal>
      </React.Fragment>
    );
  }
}

export default withNamespaces()(Legend);



// WEBPACK FOOTER //
// ./src/Legend.jsx